import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RevealMode } from '../proxy/redaction-settings.model';

export interface RevealChangedEvent {
  mode: RevealMode;
  count: number;
  startCount: number;
  endCount: number;
}

@Component({
  selector: 'cai-redaction-reveal-chars-panel',
  templateUrl: './redaction-reveal-chars-panel.component.html',
  styleUrls: ['./redaction-reveal-chars-panel.component.scss'],
  standalone: false,
})
export class RedactionRevealCharsPanelComponent {
  readonly RevealMode = RevealMode;

  @Input() revealMode: RevealMode = RevealMode.Off;
  @Input() revealCount: number = 0;
  @Input() revealStartCount: number = 0;
  @Input() revealEndCount: number = 0;
  @Input() isReadOnly = false;
  @Output() changed = new EventEmitter<RevealChangedEvent>();

  onRevealModeChanged(mode: RevealMode) {
    let count: number;
    const startCount = this.revealStartCount;
    const endCount = this.revealEndCount;

    if (mode === RevealMode.Start) {
      count = startCount;
    } else if (mode === RevealMode.End) {
      count = endCount;
    } else {
      count = 0;
    }

    this.changed.emit({ mode, count, startCount, endCount });
  }

  onRevealCountChanged(count: number) {
    let startCount = this.revealStartCount;
    let endCount = this.revealEndCount;

    if (this.revealMode === RevealMode.Start) {
      startCount = count;
    } else if (this.revealMode === RevealMode.End) {
      endCount = count;
    }

    this.changed.emit({ mode: this.revealMode, count, startCount, endCount });
  }
}
